import { AbstractControl, ValidatorFn } from "@angular/forms";

export function periodValidator(firstDateControlName: string, secondDateControlName: string): ValidatorFn {
    return (abstractControl: AbstractControl) => {
        const control = abstractControl.get(firstDateControlName);
        const endControl = abstractControl.get(secondDateControlName);

        if (endControl!.errors && !endControl!.errors?.['periodValidator']) {
            return null;
        }

        if (control!.value > endControl!.value) {
          const error = { periodValidator: 'End Date should be greater or equal.' };
          endControl!.setErrors(error);
          return error;
        } else {
          endControl!.setErrors(null);
          return null;
        }
    }
  }